import { inject, InjectionToken } from '@angular/core';

import { WINDOW } from '@core/utilities/window';

export const RESIZE_OBSERVER_SUPPORT = new InjectionToken<boolean>('Resize Observer API support', {
  providedIn: 'root',
  factory: () => !!(inject(WINDOW) as any).ResizeObserver,
});
